import config from "../../common/config";
import CardContainer from "../../components/cardContainer/cardContainer";
import partnersList from "./aqarPartners";
import styles from "./partnersPage.module.scss";

export default function PartnersPage() {
  return (
    <CardContainer>
      <div className={styles.partnersContainer}>
        <h1 className={styles.header}>شركاء النجاح</h1>
        <div className={styles.images}>
          {partnersList.map((partner) => (
            <img
              key={partner.name}
              src={`${config.PARTNERS_BASE_URL}${partner.logo}`}
              alt={partner.label}
              width={200}
              height={200}
            />
          ))}
        </div>
      </div>
    </CardContainer>
  );
}
